if (!customElements.get("product-tabs")) {
  customElements.define(
    "product-tabs",
    class ProductTabs extends HTMLElement {
      constructor() {
        super();
        this.querySelectorAll(".product-tabs--header a").forEach((tab) => {
          tab.addEventListener("click", this.handleTabClick.bind(this));
        });
      }

      handleTabClick(event) {
        event.preventDefault();
        this.querySelector(
          ".product-tabs--header .link.active",
        ).classList.remove("active");
        event.target.classList.add("active");

        this.querySelector(`.tab-content:not(.hidden)`).classList.add("hidden");
        this.querySelector(`#${event.target.dataset.target}`).classList.remove(
          "hidden",
        );
        let title = this.querySelector(
          ".product-tabs--header .link.active",
        ).innerHTML;
        this.querySelector(".product-tabs--header summary").setAttribute(
          "data-title",
          "Filter: " + title,
        );

        if (window.outerWidth < 750) {
          document
            .querySelector(".product-tabs-nav-container")
            .classList.remove("active");
          document
            .querySelector("product-tabs details")
            .removeAttribute("open");
        }
      }
    },
  );

  let scrollPosition = 0;
  let scrollPosition_check = 0;

  document.addEventListener("scroll", (event) => {
    if (window.outerWidth < 750) {
      scrollPosition = window.scrollY;

      let scroll_direction = scrollPosition_check - scrollPosition;

      if (scroll_direction < 0 && scroll_direction > -100) {
        document.querySelector("product-tabs details").removeAttribute("open");
        document
          .querySelector(".product-tabs-nav-container")
          .classList.remove("active");
      }
      scrollPosition_check = scrollPosition;
    }
  });
  if (window.outerWidth > 750) {
    document.querySelector("product-tabs details").setAttribute("open", true);
  } else {
    document
      .querySelector("product-tabs details summary")
      .addEventListener("click", (event) => {
        if (
          document
            .querySelector(".product-tabs-nav-container")
            .classList.contains("active") == false
        ) {
          event.preventDefault();
          document
            .querySelector(".shopify-section-header-sticky")
            .classList.add("shopify-section-header-hidden");
          document
            .querySelector(".product-tabs-nav-container")
            .classList.add("active");
          document
            .querySelector("product-tabs details")
            .setAttribute("open", true);
        }
      });

    document
      .querySelector(".product-tabs-nav-title")
      .addEventListener("click", (event) => {
        // if(document.querySelector('.product-tabs-nav-container').classList.contains('active') == false){
        event.preventDefault();
        document
          .querySelector(".product-tabs-nav-container")
          .classList.remove("active");
        document.querySelector("product-tabs details").removeAttribute("open");
        // }
      });
  }
}
